import { useEffect } from "react";
import {
  fetchChooseUs,
  fetchHomeAbout,
  fetchHomeHighlights,
  fetchHomeMessage,
  fetchHomeSliders,
  // fetchHomeTestimonial,
  // fetchHomeTestimonialHeader,
  fetchHomeTiles,
  fetchTilesHeader,
} from "../api/HomeApi";
// import {
//   fetchfacultiesHeader,
//   fetchfacultiesMember,
// } from "../api/FacultiesApi";
import { fetchFacilitiesList } from "../api/FacilitiesApi";
import { fetchActivitiesList } from "../api/ActivitiesApi";
import { fetchgalleryHeader, fetchgalleryImages } from "../api/GalleryApi";
import {
  fetchAboutBanner,
  // fetchcertificateHeader,
  // fetchcertificateList,
  fetchjoincommunitiesHeader,
  fetchManagementTeamImage,
  fetchManagementTeamMessage,
  fetchobjective,
  fetchobjectivetitle,
  fetchvision,
  fetchvisionObjectiveHeader,
  fetchvisiontitle,
  fetchwhyEga,
} from "../api/AboutApi";
import { fetchcontactFormHeader, fetchcontactHeader } from "../api/ContactApi";
import { fetchAllBanner, fetchCalendar } from "../api/CompanyDetailsApi";
import { fetchPolicies } from "../api/AdmissionApi";
import { fetchCoreValues } from "../api/CoreValuesApi";

export const fetchAllData = async ({
  companyDetailsData,
  setAllData,
  setLoading,
}) => {
  if (typeof setLoading === "function") setLoading(true);

  if (companyDetailsData.length === 0) {
    try {
      const [
        homeSliderData,
        homeTilesHeaderData,
        homeTilesData,
        homeAboutData,
        homeMessageData,
        managementTeamMessageData,
        managementTeamImageData,
        homeChooseUsData,
        homeHighlightsData,
        facilitiesList,
        activities,
        galleryHeader,
        galleryImage,
        banner,
        visionObjectiveHeader,
        visionDataTitle,
        visionData,
        objectiveDataTitle,
        objectiveData,
        whyEgaData,
        joinCommunityHeader,
        contactHeader,
        contactFromHeader,
        policiesData,
        calendarData,
        allBannerData,
        coreValuesData,
      ] = await Promise.all([
        fetchHomeSliders(),
        fetchTilesHeader(),
        fetchHomeTiles(),
        fetchHomeAbout(),
        fetchHomeMessage(),
        fetchManagementTeamMessage(),
        fetchManagementTeamImage(),
        fetchChooseUs(),
        fetchHomeHighlights(),
        fetchFacilitiesList(),
        fetchActivitiesList(),
        fetchgalleryHeader(),
        fetchgalleryImages(),
        fetchAboutBanner(),
        fetchvisionObjectiveHeader(),
        fetchvisiontitle(),
        fetchvision(),
        fetchobjectivetitle(),
        fetchobjective(),
        fetchwhyEga(),
        fetchjoincommunitiesHeader(),
        fetchcontactHeader(),
        fetchcontactFormHeader(),
        fetchPolicies(),
        fetchCalendar(),
        fetchAllBanner(),
        fetchCoreValues(),
      ]);

      setAllData((prev) => ({
        ...prev,
        sliderData: homeSliderData,
        tilesHeaderData: homeTilesHeaderData,
        tilesData: homeTilesData,
        aboutData: homeAboutData,
        chairmenData: homeMessageData,
        managementTeamMessageData: managementTeamMessageData,
        managementTeamImageData: managementTeamImageData,
        chooseUsData: homeChooseUsData,
        highlightsData: homeHighlightsData,
        facilitiesData: facilitiesList,
        activitiesData: activities,
        galleryHeaderData: galleryHeader,
        galleryImagesData: galleryImage,
        bannerData: banner,
        visionObjectiveHeaderData: visionObjectiveHeader,
        visionDataTitle: visionDataTitle,
        visionData: visionData,
        objectiveDataTitle: objectiveDataTitle,
        objectiveData: objectiveData,
        whyEgaData: whyEgaData,
        joinCommunityHeaderData: joinCommunityHeader,
        contactHeaderData: contactHeader,
        contactFormHeaderData: contactFromHeader,
        policiesData: policiesData,
        calendarData: calendarData,
        allBannerData: allBannerData,
        coreValuesData: coreValuesData,
      }));

      if (typeof setLoading === "function") {
        setTimeout(() => setLoading(false), 500);
      }
    } catch (err) {
      console.error("Server Error", err);
      if (typeof setLoading === "function") {
        setTimeout(() => setLoading(false), 500);
      }
    }
  } else {
    if (typeof setLoading === "function") {
      setTimeout(() => setLoading(false), 500);
    }
  }
};

export const FetchAllApi = ({ companyDetailsData, setAllData, setLoading }) => {
  useEffect(() => {
    fetchAllData({ companyDetailsData, setAllData, setLoading });
  }, [companyDetailsData, setAllData, setLoading]);
};
